<template>
  <div id="app">
    <el-row>
      <el-col :span="24">当前页面：{{this.$route.query.menuName}}</el-col>
      <div style="height: 10px;"></div>
      <el-col :span="24">
        设置维护升级:
        <el-radio-group v-model="menuSwitch">
          <el-radio :label=true>开</el-radio>
          <el-radio :label=false>关闭</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <div style="height: 20px;"></div>
<!--    <vue-tinymce-->
<!--            v-model="content"-->
<!--            :setting="setting"-->
<!--            :key="tinymceFlag"/>-->
    <Tinymce ref="editor" v-model="content"  :height="400" />
    <div style="height: 20px;"></div>

    <div>
      <el-button type="primary" @click="save()">保存</el-button>
<!--      <el-button type="primary" @click="save1()">测试跳转维护升级页面</el-button>-->
    </div>
  </div>
</template>

<script>

  import Tinymce from './Tinymce'

  export default {
    name: "maintainUpdate",
    //import引入的组件需要注入到对象中才能使用
    components: {Tinymce},
    data(){
      return {
        content: '',
        setting: {
          branding: false,  // 隐藏富文本编辑器组件的商标消息” Powered by TinyMCE”
          menubar: false,
          toolbar: "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | fontsizeselect forecolor backcolor | bold italic underline strikethrough |",
          toolbar_drawer: "sliding",
          quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
          plugins: "link image media table lists fullscreen quickbars",
          language: 'zh_CN',
          height: 350
        },
        menuSwitch:'',
        tinymceFlag:1
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      // 数据初始化
      init() {
        this.$request
          .post('/sys/sysmenuswitch/getOne', {menuUrl:this.$route.query.menuUrl})
          .then((res, total, code, data) => {
            console.log('init')
            console.log(data)
            if (data.code === 1) {
              this.menuSwitch = data.data.menuSwitch
              this.$set(this,'content',data.data.content)
              // this.content = data.data.content
            }else {
              this.$message.warning(data.msg)
            }
            this.tinymceFlag++;
          })
          .catch((err) => {
            console.log(err)
          })
      },
      save(){
        this.$request
          .post('/sys/sysmenuswitch/updateSwitch', {menuUrl:this.$route.query.menuUrl,menuSwitch:this.menuSwitch,content:this.content,menuId:this.$route.query.menuId,nameCn:this.$route.query.menuName})
          .then((res, total, code, data) => {
            console.log('init')
            console.log(data)
            if (data.code === 1) {
              this.$message.info('保存成功')
              this.tabRemove()
            }else {
              this.$message.warning(data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })

      },

      // 删除当前页面
      tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      },

      save1(){
        this.$router.push({
          name: 'sys-maintain-maintainInfo'
        })
      },
    },

    //创建前：
    beforeCreate() {
      console.log('beforeCreate')
    },
    // 创建完成 实例已经创建完成之后被调用
    created() {
      console.log('created')
    },
    //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
    beforeMount() {
      console.log('beforeMount')
    },
    // 挂载完成：
    mounted() {
      console.log('mounted')
    },
    activated() {
      this.init()
      this.tinymceFlag++;
    },
    // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() {
      console.log('beforeUpdate')
    },
    // 更新成功
    updated() {
      console.log('updated')
    },
    // 实例销毁之前调用
    beforeDestroy() {
      console.log('beforeDestroy')
    },
    //Vue 实例销毁后调用
    destroyed() {
      console.log('destroyed')
    }

  }
</script>

<style scoped>
</style>
